import React, { useState, useEffect } from 'react';
import { Clock, Save } from 'lucide-react';

const Schedule = () => {
  const [schedule, setSchedule] = useState({
    monday: { start: '09:00', end: '17:00', available: true },
    tuesday: { start: '09:00', end: '17:00', available: true },
    wednesday: { start: '09:00', end: '17:00', available: true },
    thursday: { start: '09:00', end: '17:00', available: true },
    friday: { start: '09:00', end: '17:00', available: true },
    saturday: { start: '09:00', end: '13:00', available: false },
    sunday: { start: '09:00', end: '13:00', available: false }
  });

  // Загружаем существующее расписание при загрузке компонента
  useEffect(() => {
    fetch('/api/doctors/1/schedule')
      .then(response => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then(data => {
        console.log('Загруженное расписание:', data);
        if (data && data.length > 0) {
          const newSchedule = {
            monday: { start: '09:00', end: '17:00', available: true },
            tuesday: { start: '09:00', end: '17:00', available: true },
            wednesday: { start: '09:00', end: '17:00', available: true },
            thursday: { start: '09:00', end: '17:00', available: true },
            friday: { start: '09:00', end: '17:00', available: true },
            saturday: { start: '09:00', end: '13:00', available: false },
            sunday: { start: '09:00', end: '13:00', available: false }
          };
          data.forEach(item => {
            // Находим день по числовому значению
            const dayKey = days.find(day => day.value === item.day_of_week)?.key;
            if (dayKey && newSchedule[dayKey]) {
              newSchedule[dayKey] = {
                start: item.start_time,
                end: item.end_time,
                available: item.is_available === 1
              };
            }
          });
          setSchedule(newSchedule);
        }
      })
      .catch(error => {
        console.error('Ошибка загрузки расписания:', error);
      });
  }, []);

  const days = [
    { key: 'monday', label: 'Понедельник', value: 1 },
    { key: 'tuesday', label: 'Вторник', value: 2 },
    { key: 'wednesday', label: 'Среда', value: 3 },
    { key: 'thursday', label: 'Четверг', value: 4 },
    { key: 'friday', label: 'Пятница', value: 5 },
    { key: 'saturday', label: 'Суббота', value: 6 },
    { key: 'sunday', label: 'Воскресенье', value: 7 }
  ];

  const handleSave = () => {
    // Преобразуем данные в формат, который ожидает сервер
    const scheduleData = days.map(day => ({
      day_of_week: day.value,
      start_time: schedule[day.key].start,
      end_time: schedule[day.key].end,
      is_available: schedule[day.key].available
    }));

    console.log('Отправляем расписание:', { schedule: scheduleData });

    fetch('/api/doctors/1/schedule', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ schedule: scheduleData })
    })
    .then(response => {
      console.log('Ответ сервера:', response.status);
      if (response.ok) {
        return response.json();
      } else {
        return response.text().then(text => {
          console.error('Текст ошибки:', text);
          throw new Error(`Ошибка сервера: ${response.status}`);
        });
      }
    })
    .then(data => {
      console.log('Данные ответа:', data);
      alert('Расписание сохранено!');
    })
    .catch(error => {
      console.error('Ошибка:', error);
      alert('Ошибка при сохранении расписания: ' + error.message);
    });
  };

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">Расписание</h1>
          <p className="text-gray-600">Управление рабочим временем</p>
        </div>
        <button
          onClick={handleSave}
          className="flex items-center px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
        >
          <Save className="h-5 w-5 mr-2" />
          Сохранить
        </button>
      </div>

      <div className="bg-white shadow rounded-lg">
        <div className="px-6 py-4 border-b border-gray-200">
          <h3 className="text-lg font-medium text-gray-900">Рабочее время</h3>
        </div>
        <div className="p-6">
          <div className="space-y-4">
            {days.map((day) => (
              <div key={day.key} className="flex items-center space-x-4">
                <div className="w-32">
                  <label className="flex items-center">
                    <input
                      type="checkbox"
                      checked={schedule[day.key].available}
                      onChange={(e) => setSchedule({
                        ...schedule,
                        [day.key]: { ...schedule[day.key], available: e.target.checked }
                      })}
                      className="mr-2"
                    />
                    {day.label}
                  </label>
                </div>
                {schedule[day.key].available && (
                  <>
                    <div className="flex items-center space-x-2">
                      <Clock className="h-4 w-4 text-gray-400" />
                      <input
                        type="time"
                        value={schedule[day.key].start}
                        onChange={(e) => setSchedule({
                          ...schedule,
                          [day.key]: { ...schedule[day.key], start: e.target.value }
                        })}
                        className="border border-gray-300 rounded px-2 py-1"
                      />
                      <span className="text-gray-500">—</span>
                      <input
                        type="time"
                        value={schedule[day.key].end}
                        onChange={(e) => setSchedule({
                          ...schedule,
                          [day.key]: { ...schedule[day.key], end: e.target.value }
                        })}
                        className="border border-gray-300 rounded px-2 py-1"
                      />
                    </div>
                  </>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Schedule; 